import React, { useEffect, useState, useRef } from "react";
import tmdbApi from "../api/tmdbApi";
import { useParams } from "react-router-dom";
import Footer from "../components/footer/Footer";
import SideMenu from "../pages/student/SideMenu";
// import Sidebar from "../components/dashboard/sidebar";
import Header from "../components/dashboard/header";
import { useNavigate, Link } from "react-router-dom";

import total from "../assets/images/icons/total-score.svg"
import percentage from "../assets/images/icons/percentage.svg"
import OpenSeadragon from "openseadragon";
import deepZoom from "../assets/images/icons/Dna-dz.svg";


const ModuleResult = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [ans, setAns] = useState([]);
    const [cases, setCases] = useState([]);
    const [moduleInfo, setModuleInfo] = useState(null);
    const [popupImage, setPopupImage] = useState(null);
    const [popupPngImage, setPopupPngImage] = useState(null);

    useEffect(() => {
        getModuleInfo();
        // getCpcQuizInfo();
    }, [id]);

    const getModuleInfo = async () => {

        try {
            const percentileRes = await tmdbApi.learningModulePercentile(id);
            if (percentileRes?.result) {
                // debugger
                const response = await tmdbApi.moduleInfo(percentileRes.result[0].moduleid);
                if (response?.result && response?.result?.data.length > 0) {
                    let res = { ...response.result?.data[0] };
                    res['percentile'] = percentileRes.result[0].percentile;
                    res['cases'] = percentileRes.result[0].cases;
                    res['moduleScore'] = percentileRes.result[0].moduleScore;
                    console.log(res, "res")
                    setModuleInfo(res);
                }
            }
        } catch (err) {
            setModuleInfo(null);
        }
    };
    // removed extra closing brace here

    // const getCpcQuizInfo = async () => {
    //     const response = await tmdbApi.cpcParticipantAnswersInfo(id);
    //     if (typeof response?.result !== 'string') {
    //         setAns(response?.result || []);
    //     }
    //     const res = await tmdbApi.cpcCaseInfo();
    //     if (res?.result) {
    //         setCases(res?.result || []);
    //     }
    // };

    const handlePngPopupImage = (imageUrl) => {
        setShowImagePopup(true);
        setPopupPngImage(imageUrl);
    };

    const handlePopupload = (e) => {
        setPopupLoading(true);
    };

    const handleBack = () => {
        navigate(-1);
    };

    const customComponents = {
        DropdownIndicator: () => null, // Remove the dropdown indicator
        IndicatorSeparator: () => null, // Optionally remove the separator
    };
    const viewerRef = useRef(null);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");
    const [dzipopupImage, setDZIPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [viewer, setViewer] = useState(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [image, setImg] = useState('');
    const [imageCloudfront, setimageCloudfront] = useState('');
    const [resourceImg, setResourceImg] = useState('');
    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront);
                    setimageCloudfront(window.site.common.imageCloudfront);
                    setResourceImg(window.site.common.resourceBucket);
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront);
            setimageCloudfront(window.site.common.imageCloudfront);
            setResourceImg(window.site.common.resourceBucket);
        }
    }, [window.site]);
    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity


        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };
    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const handleVideoPopupClose = () => {
        setShowVideoPopup(false);
    };
    return (
        <div id="layout-wrapper">
            <Header />
           <SideMenu />

            <div className="main-content user-management cpc-results-table" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row  breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12 cpc-results-line p-0">
                                <div className="d-flex align-items-center justify-content-between col-lg-12">
                                    <div className="col-lg-8">
                                        <h4 className="card-title" id="breadcrumb-title">
                                            Module Results
                                        </h4>


                                    </div>
                                    <div className="answer-block answer-flex col-lg-4">
                                        <div className="answer-row">
                                            <span className="correct-answer answer-dot"></span>
                                            <p>Admin Answer</p>
                                        </div>
                                        <div className="answer-row">
                                            <span className="actual-answer answer-dot"></span>
                                            <p>Your Correct Answer</p>
                                        </div>
                                        <a onClick={handleBack} className="create-quiz-btn">back</a>
                                    </div>


                                </div>
                            </div>
                        </div>


                        <div className="row table-data">



                            <div className="col-12 d-flex justify-content-between case-main-heading">

                                <div className="col-lg-8">
                                    <h2 className="quiz-title">{moduleInfo?.name || (ans && ans?.cpcDetails?.title)}</h2>
                                    <p className="quiz-para">
                                        <div dangerouslySetInnerHTML={{ __html: moduleInfo?.description || (ans && ans?.cpcDetails?.description) }} />
                                    </p>
                                    {/* Display module image if available */}

                                    <p className="marks-sidehe"><img src={total} alt="" /> Total Score : <span className="marks-txt">{moduleInfo?.moduleScore}</span></p>
                                    {/* <p className="marks-sidehe"><img src={percentage} alt="" /> Percentile : <span className="marks-txt">{ans && ans?.participantAnswers && ans?.participantAnswers[0] && ans?.participantAnswers[0]?.percentileRank}</span></p> */}
                                </div>
                                <div className="col-lg-3">
                                    {/* <h2 className="quiz-title">Video</h2> */}
                                    <div className="video-card">
                                        {moduleInfo?.modulefiles && moduleInfo.modulefiles.length > 0 && (
                                            <div style={{ margin: '20px 0' }}>
                                                <img
                                                    src={imageCloudfront + moduleInfo.modulefiles[0].sourcepath}
                                                    alt={moduleInfo.modulefiles[0].filename}
                                                />
                                            </div>
                                        )}

                                    </div>
                                </div>
                                <div className="cpcquiz-line1"></div>
                            </div>

                            {moduleInfo?.cases?.map((item, qIndex) => {
                                // const caseData = cases.find(c => c.caseid === item.caseid);
                                // const caseDesc = caseData?.clinicalhistory || "";
                                // const answers = item.answers || [];
                                return (
                                    <div className="col-12  case-main-cases mt-3" key={qIndex}>
                                        <div className="d-flex justify-content-between">
                                            <div className="col-lg-8">
                                                <h2 className="quiz-title">
                                                    {/* {item?.diagnosis} */}

                                                    {"Case " + (qIndex + 1)}
                                                </h2>
                                                <p className="quiz-para" dangerouslySetInnerHTML={{ __html: item?.caseDetails?.clinicalhistory }}></p>



                                                {item?.caseDetails?.explanation && <p><b>Explanation:</b> {item?.caseDetails?.explanation}</p>}

                                                <p>{item?.answer1?.label ? <span><b>Diagnostics: </b>{item?.answer1?.label}</span> : ''}
                                                    {item?.answer2?.label ? `, ${item?.answer2?.label}` : ''}
                                                    {item?.answer11?.label ? `, ${item?.answer11?.label}` : ''}</p>
                                                {/* {item?.adminAnswer && <p><b>Answer:</b> {item?.adminAnswer}</p>} */}

                                            </div>
                                            <div className="col-lg-3 cpc-results-img">
                                                <div className="d-flex gap-1 flex-wrap case-block question_block">


                                                    <div className={item?.files?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>
                                                        <div className="d-grid justify-content-start gap-2 align-items-center">
                                                            <div>
                                                                {item?.caseDetails?.files && item?.caseDetails?.files.length > 0 && <p className="mt-2 quiz-title">Histological Photos</p>}
                                                                {item?.caseDetails?.files?.map((file, fileIndex) => (
                                                                    file.status == "COMPLETED" &&
                                                                    <div
                                                                        key={fileIndex}
                                                                        className="img"
                                                                        style={{ width: 'auto' }}
                                                                        onClick={(e) => {
                                                                            setPopupOpen(true);
                                                                            setImageDimensions({ width: file?.width, height: file?.height });
                                                                            let path = file?.dziUrl || "";

                                                                            // Remove the first slash if present
                                                                            if (path.startsWith("/")) {
                                                                                path = path.slice(1);
                                                                            }
                                                                            path = path + "_files/"

                                                                            setDziUrl(imageCloudfront + path);
                                                                            setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)

                                                                            setPopupImage(imageCloudfront + file?.sourcepath);
                                                                            handlePopupload(e);
                                                                        }}
                                                                    >
                                                                        <span className="material-symbols-outlined img_view">zoom_out_map</span>

                                                                        <span className="default-img deep-zoom"><img src={file?.thumbnailUrl ? `${imageCloudfront}${file?.thumbnailUrl?.replace(/ /g, '%20')}?auto=compress,format` : deepZoom} alt={file?.originalFilename} /></span>

                                                                        {/* <img
                                                                                                        src={`${imageCloudfront}${file?.filepath.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                                        alt={`Quiz Image ${fileIndex + 1}`}
                                                                                                        loading="lazy"
                                                                                                    /> */}

                                                                    </div>


                                                                ))}
                                                            </div>
                                                            <div className="img_block mt-1">

                                                                {item?.historyfiles && item?.historyfiles.length > 0 &&
                                                                    <p className="quiz-title">Clinical History Photos</p>}

                                                                {item?.historyfiles && item?.historyfiles.length > 0 && item?.historyfiles?.map((file, key) => {

                                                                    let imagePath = `${imageCloudfront}${file?.sourcepath && file?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`

                                                                    return (

                                                                        <div
                                                                            key={key}
                                                                            className="img"
                                                                            style={{ width: 'auto' }}
                                                                            onClick={(e) => handlePngPopupImage(imagePath)}
                                                                        >
                                                                            <span className="material-symbols-outlined img_view img-zoom">zoom_out_map</span>
                                                                            <img
                                                                                src={`${imageCloudfront}${file?.sourcepath.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                alt={`Image ${key + 1}`}
                                                                                loading="lazy"
                                                                            />
                                                                        </div>


                                                                    )
                                                                })}


                                                            </div>


                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-4">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr className="case-question" style={{ backgroundColor: '#ffffff' }}>
                                                        <th>Answer</th>

                                                        <th className="text-center">Score</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item?.answers?.filter(ansItem => ansItem?.hasOwnProperty('isCorrect')).map((ansItem, aIndex) => {
                                                        const rowStyle = ansItem?.isCorrect && ansItem?.weightage > 0
                                                            ? { backgroundColor: '#b4dfdb' }
                                                            : { backgroundColor: 'none' };

                                                        return (
                                                            <tr key={aIndex} className="case-question" style={rowStyle}>
                                                                <td>{ansItem?.answer}</td>
                                                                <td className="text-center">{ansItem?.score || 0}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                    {item?.adminAnswer && (
                                                        <tr key={'admin-ans'} style={{ backgroundColor: '#FFE8DB' }}>
                                                            <td>{item?.adminAnswer}</td>
                                                            <td className="text-center">1</td>
                                                        </tr>
                                                    )}
                                                </tbody>

                                            </table>


                                        </div>
                                        {/* <div className="cpcquiz-line1"></div> */}
                                    </div>
                                );
                            }
                            )}


                        </div>
                    </div>
                    <Footer />
                </div>




            </div>
            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 20px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #dee2e6"
                            }}>
                                <h3 style={{ fontSize: "18px" }}>
                                    {/* {dziUrlFile ? dziUrlFile : ""} */}
                                    </h3>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    {/* <button
                                    className="create-quiz-btn border-0"
                                    onClick={resetZoom}
                                >
                                    Reset View
                                </button> */}
                                    {/* <button
                                    onClick={() => rotateImage(90)}
                                    className="create-quiz-btn border-0"

                                >
                                    Rotate 90°
                                </button> */}
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            border: "none",
                                            fontWeight: "800",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {/* Instructions */}
                                {/* <div style={{
                                position: "absolute",
                                bottom: "20px",
                                left: "20px",
                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                padding: "10px",
                                borderRadius: "5px",
                                fontSize: "12px"
                            }}>
                                <p style={{ margin: "2px 0" }}>• Zoom with mouse wheel or pinch gesture</p>
                                <p style={{ margin: "2px 0" }}>• Pan by clicking and dragging</p>
                                <p style={{ margin: "2px 0" }}>• Use the navigator in the bottom-right for orientation</p>
                                <p style={{ margin: "2px 0" }}>• Use toolbar buttons to rotate or reset view</p>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {dziUrl && (
                <section className="viewer-section">
                    <div className="viewer-header">
                        <h2>Deep Zoom Viewer</h2>
                        <div className="viewer-controls">
                            <button className="control-button" onClick={() => window.location.reload()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 2v6h-6"></path>
                                    <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                                    <path d="M3 22v-6h6"></path>
                                    <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                                </svg>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>

                    <div className="viewer-container">
                        <div id="openseadragon-viewer" ref={viewerRef}></div>
                        <div className="viewer-instructions">
                            <p>• Zoom with mouse wheel or pinch gesture</p>
                            <p>• Pan by clicking and dragging</p>
                            <p>• Use the navigator in the bottom-right for orientation</p>
                        </div>
                    </div>
                </section>
            )}
        </div>



    )

}
export default ModuleResult;